import { render, staticRenderFns } from "./GlobalSCSS.vue?vue&type=template&id=4eaa6c4a"
import script from "./GlobalSCSS.vue?vue&type=script&lang=js"
export * from "./GlobalSCSS.vue?vue&type=script&lang=js"
import style0 from "./GlobalSCSS.vue?vue&type=style&index=0&id=4eaa6c4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports